
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/conference",
      function () {
        return require("private-next-pages/event/conference/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/conference"])
      });
    }
  